export const getAllCourses = (state, courses, total) => {
  const updatedCourses = state.page === 1 ? courses : [...state.courses, ...courses];
  
  return {
    ...state,
    courses: updatedCourses,
    total: total,
  };
};

export const getCourse = (state, course) => {
  return {
    ...state,
    currentCourse: course,
  };
};

export const createCourse = (state, course) => {
  var newCourse = Array.from(new Set([course, ...state.courses]));

  return {
    ...state,
    courses: newCourse,
    total: state.total + 1,
  };
};

export const updateCourse = (state, course) => {
  const courseCopy = [...state.courses];

  courseCopy[
    courseCopy.findIndex((tCourse) => {
      return tCourse.id === course.id;
    })
  ] = {
    ...course,
  };

  return {
    ...state,
    courses: courseCopy,
    currentCourse: state.currentCourse?.id === course.id ? course : state.currentCourse,
  };
};

export const deleteCourse = (state, courseId) => {
  return {
    ...state,
    courses: state.courses.filter((course) => course.id !== courseId),
    total: state.total - 1,
  };
};

export const setLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue,
  };
};

export const pageIncreament = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
};

export const clearAll = () => {
  return {
    courses: [],
    currentCourse: null,
    total: 0,
    isLoading: true,
    page: 1,
  };
}; 

// My Courses utility functions
export const getMyCoursesFunc = (state, courses, total) => {
  const updatedCourses = state.page === 1 ? courses : [...state.courses, ...courses];
  
  return {
    ...state,
    courses: updatedCourses,
    total: total,
  };
};

export const setMyCoursesLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue,
  };
};

export const myCoursesPageIncrement = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
};

export const clearMyCourses = () => {
  return {
    courses: [],
    total: 0,
    isLoading: true,
    page: 1,
  };
}; 